export default __webpack_public_path__ + "assets/images/5.4d202e.webp";